import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { HashLoader } from 'react-spinners';
import { AuthContext } from '../..';

export default function ProtectedRoutes() {
  const { authStatus, companyid } = useContext(AuthContext);

  if (authStatus === null) {
    return <div><HashLoader color="#f0f9ff" /></div>;
  }

  return authStatus ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace />
  );
}